import { SERVICE_HEADER_API_URL } from 'constants/ApiConstants';

import * as types from './actionTypes';

/**
 * @param {string} dealerId
 * @param {import('./types/actions').fetchServiceHeaderPayload} search
 * @param {Object} [meta={}]
 * @returns {import('./types/actions').FetchServiceHeaderAction}
 */
export const fetchServiceHeader = (dealerId, search, meta = {}) => ({
  type: types.FETCH_SERVICE_HEADER,
  payload: {
    request: {
      method: 'GET',
      url: SERVICE_HEADER_API_URL,
      params: {
        dealerId,
        ...search,
      },
    },
  },
  meta,
});

/**
 * @param {import('./types/wrappedServiceHeader').WrappedServiceHeader[]} entries
 * @param {Object} [meta={}]
 * @returns {import('./types/actions').FetchServiceHeaderSuccessAction}
 */
export const fetchServiceHeaderSuccess = (entries, meta = {}) => ({
  type: types.FETCH_SERVICE_HEADER_SUCCESS,
  payload: entries,
  meta,
});

/**
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import('./types/actions').FetchServiceHeaderErrorAction}
 */
export const fetchServiceHeaderFailure = (error, meta = {}) => ({
  type: types.FETCH_SERVICE_HEADER_FAILURE,
  payload: error,
  error: true,
  meta,
});

/**
 * @param {import('./types/wrappedServiceHeader').WrappedServiceHeader} entry
 * @param {Object} [meta={}]
 * @returns {import('./types/actions').SelectEntryAction}
 */
export const selectEntry = (entry, meta) => ({
  type: types.SELECT_DMS_ENTRY,
  payload: entry,
  meta,
});

/**
 * @param {undefined} payload
 * @param {Object} [meta={}]
 * @returns {import('./types/actions').OpenModalAction}
 */
export const openModal = (payload, meta = {}) => ({
  type: types.OPEN_MODAL,
  payload,
  meta,
});

/**
 * @param {undefined} payload
 * @param {Object} [meta={}]
 * @returns {import('./types/actions').CloseModalAction}
 */
export const closeModal = (payload, meta = {}) => ({
  type: types.CLOSE_MODAL,
  payload,
  meta,
});
